__turbopack_context__.v({
  "backdrop": "PorQuePedimosDatosModal-module__Akatoq__backdrop",
  "fadeIn": "PorQuePedimosDatosModal-module__Akatoq__fadeIn",
  "iconBadge": "PorQuePedimosDatosModal-module__Akatoq__iconBadge",
  "infoCard": "PorQuePedimosDatosModal-module__Akatoq__infoCard",
  "infoCardsContainer": "PorQuePedimosDatosModal-module__Akatoq__infoCardsContainer",
  "itemIconCircle": "PorQuePedimosDatosModal-module__Akatoq__itemIconCircle",
  "modalCard": "PorQuePedimosDatosModal-module__Akatoq__modalCard",
  "understoodBtn": "PorQuePedimosDatosModal-module__Akatoq__understoodBtn",
  "zoomIn": "PorQuePedimosDatosModal-module__Akatoq__zoomIn",
});
